// PasswordResetPanel.js
import React, { useState } from 'react';
import styles from './PasswordResetPanel.module.css'; 
import { InnocodeButton, InnocodeCheckmarkbox, InnocodeInput } from '@intsoft/innocode-core';

function PasswordResetPanel({ onNext }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [pwValidations, setPwValidations] = useState({
    hasEnglish: false,
    hasNumber: false,
    hasLength: false,
    isMatch: false,
  });

  const checkPasswordValidation = (pw, confirmPw) => {
    setPwValidations({
      hasEnglish: /[a-zA-Z]/.test(pw),
      hasNumber: /[0-9]/.test(pw),
      hasLength: pw.length >= 8 && pw.length <= 20,
      isMatch: pw === confirmPw && confirmPw.length > 0,
    });
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    checkPasswordValidation(newPassword, confirmPassword);
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    checkPasswordValidation(password, newConfirmPassword);
  };

  // 비밀번호 가시성 토글 함수
  const handlePasswordToggle = () => {
    setShowPassword(!showPassword);
  };

  // 비밀번호 확인 가시성 토글 함수
  const handleConfirmPasswordToggle = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const isNextButtonEnabled = Object.values(pwValidations).every(Boolean);

  return (
    <div className={styles.content_wrapper}>
      <div className={styles.signup_section}>
        <div className={styles.signup_title_row}>
          <div className={`innocode-typography--title-sm innocode-typography--bold ${styles.signup_title}`}>비밀번호 설정</div>
        </div>
        <div className={styles.signup_form_label_row}>
          <div className={styles.signup_form_input_group}>
            <div className={styles.signup_form_label_inner}>
              <div className={styles.signup_form_label}>비밀번호</div>
              <div className={styles.signup_form_required}>*</div>
            </div>
            <div className={styles.signup_input_group}>
              <InnocodeInput  
                type={showPassword ? 'text' : 'password'}
                value={password}
                placeholder="비밀번호 입력"
                onChange={handlePasswordChange}
                className={styles.innocode_input}
                showTrailingContent={true}
                trailingContent={<InnocodeButton
                   theme="opacity"
                   designType="assistive"
                   enablePadding={false}
                   iconOnly={true}
                   icon={showPassword ? <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                  </svg>
                   : <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeWidth="2" d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"/>
                    <path stroke="currentColor" strokeWidth="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                  </svg>
                  }
                   onClick={handlePasswordToggle}
                >

                </InnocodeButton>}
              />
            </div>
            <div className={styles.password_check_list}>
              <InnocodeCheckmarkbox
                  className={styles.password_check_item}
                  title={"영문포함"} 
                  leadingIcon={true}
                  checked={pwValidations.hasEnglish}
                  // disabled={true}
              ></InnocodeCheckmarkbox>
              <InnocodeCheckmarkbox
                  className={styles.password_check_item}
                  title={"숫자포함"} 
                  leadingIcon={true}
                  checked={pwValidations.hasNumber}
                  // disabled={true}
              ></InnocodeCheckmarkbox>
              <InnocodeCheckmarkbox
                  className={styles.password_check_item}
                  title={"8~20자 이내"} 
                  leadingIcon={true}
                  checked={pwValidations.hasLength}
                  // disabled={true}
              ></InnocodeCheckmarkbox>
            </div>
          </div>
        </div>
        <div className={styles.signup_form_label_row}>
          <div className={styles.signup_form_input_group}>
            <div className={styles.signup_form_label_inner}>
              <div className={styles.signup_form_label}>비밀번호 확인</div>
              <div className={styles.signup_form_required}>*</div>
            </div>
            <InnocodeInput  
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                placeholder="비밀번호 확인"
                onChange={handleConfirmPasswordChange}
                className={styles.innocode_input}
                showTrailingContent={true}
                trailingContent={<InnocodeButton
                   theme="opacity"
                   designType="assistive"
                   enablePadding={false}
                   iconOnly={true}
                   icon={showConfirmPassword ? <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                  </svg>
                   : <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeWidth="2" d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"/>
                    <path stroke="currentColor" strokeWidth="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                  </svg>
                  }
                   onClick={handleConfirmPasswordToggle}
                >

                </InnocodeButton>}
              />
            <div className={styles.password_check_list}>
              <InnocodeCheckmarkbox
                    className={styles.password_check_item}
                    title={"비밀번호 일치"} 
                    leadingIcon={true}
                    checked={pwValidations.isMatch}
                    // disabled={true}
                ></InnocodeCheckmarkbox>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.submit_btn_container}>
        <InnocodeButton
          size="lg"
          onClick={() => onNext(password)}
          disabled={!isNextButtonEnabled}
          className={styles.submit_btn}
        >
          다음
        </InnocodeButton>
        {/* <button
          type="button"
          className={`${components.btn} ${components.btn_solid} ${components.btn_primary} ${components.btn_lg} ${styles.submit_btn}`}
          onClick={() => onNext(password)}
          disabled={!isNextButtonEnabled}
        >
          <span className={components.btn__text}>다음</span>
        </button> */}
      </div>
    </div>
  );
}

export default PasswordResetPanel;